import React, { useReducer } from "react";
import { Reducer, initialState, Context } from "./inc/state";

import Steps from "./components/Steps";
import Intro from "./components/Intro";

import Documents from "./components/Documents";
import Commitment from "./components/Commitment";
import Success from "./components/Success";

import Option1 from "./components/Option1";
import Option234 from "./components/Option234";
import Option5 from "./components/Option5";

//deps
// import LegalEntity from "./components/LegalEntity";
// import LegalRepresentative from "./components/LegalRepresentative";
// import Personal from "./components/Personal";

export default function () {
  const [state, dispatch] = useReducer(Reducer, initialState);
  const { step, steps, fundOption } = state;
  let pages = {};
  switch (fundOption) {
    case 1:
      pages = { 1: "Intro", 2: "Option1", 3: "Documents", 4: "Commitment", 5: "Success" };
      break;
    case 5:
      pages = { 1: "Intro", 2: "Option5", 3: "Documents", 4: "Commitment", 5: "Success" };
      break;
    default:
      pages = { 1: "Intro", 2: "Option234", 3: "Documents", 4: "Commitment", 5: "Success" };
  }

  const page = pages[step];

  return (
    <Context.Provider value={[state, dispatch]}>
      <div className="app-container">
        <Steps steps={steps} step={step} />
        {page === "Intro" && <Intro />}
        {page === "Option1" && <Option1 />}
        {page === "Option234" && <Option234 />}
        {page === "Option5" && <Option5 />}
        {page === "Documents" && <Documents />}
        {page === "Commitment" && <Commitment />}
        {page === "Success" && <Success />}
        {page !== "Success" && (
          <div className="p-3 bg-light small mt-4">
            Mocht U bij het invullen van dit formulier met vragen zitten, neem dan contact op met
            Bernard Hendrikx op het nummer 0032 477 67 99 70
          </div>
        )}
      </div>
    </Context.Provider>
  );
}
